import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { NotificationsFollowUpService } from 'src/app/tabms/services/admin/notifications/notifications-follow-up/notifications-follow-up.service';
import { forkJoin, map, Subject, switchMap, takeUntil } from 'rxjs';
import { SignalrManagerService } from 'src/app/tabms/services/global/signalr-manager.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { Auth2Service } from 'src/app/tabms/services/Auth/auth2Service.service';
import { notificationsFollowUpDto } from 'src/app/tabms/models/admin/notifications-follow-up';
import { notificationCardDto } from 'src/app/tabms/models/base/base';
import { NgScrollbar } from 'ngx-scrollbar';


@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent implements OnInit, OnDestroy, AfterViewInit {
  unReadCount: number;
  userId: string;
  currentLang: string;
  unReadNotifications: notificationCardDto[] = [];
  allNotifications: notificationCardDto[] = [];
  pageSize: number = 10

  private _selectedTab: 'unRead' | 'allNotifications' = 'unRead';

  get selectedTab(): 'unRead' | 'allNotifications' {
    return this._selectedTab;
  }

  set selectedTab(value: 'unRead' | 'allNotifications') {
    if (this._selectedTab !== value) {
      this._selectedTab = value;
      this.onTabChange(value);
    }
  }
  private destroy$: Subject<void> = new Subject<void>();

  @ViewChild('scrollbar') scrollbarRef: NgScrollbar;


  constructor(
    private notificationsFollowUpService: NotificationsFollowUpService,
    private signalRService: SignalrManagerService,
    private baseService: BaseService,
    private auth2Service: Auth2Service,
    private sessionService: SessionWrapperService,
    private themeLayoutService: ThemeLayoutService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();
    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
      }
    })
  }
  ngOnInit(): void {
    if (this.auth2Service.hasValidAccessToken()) {
      this.onSuccess();
    } else {
      this.auth2Service.tokenRecieved.pipe(takeUntil(this.destroy$)).subscribe({
        next: (success) => {
          if (success) {
            // debugger
            this.onSuccess();
          }
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.onScroll();
  }

  onSuccess() {
    let session = this.sessionService.getsessionData();
    this.userId = session.userid;

    //#region get user notifications first init
    this.showAll();
    this.showUnRead();
    //#endregion
    this.signalR();
  }

  getUserNotifications$(pageIndex, pageSize, params) {
    if (params) params = { IdentityUserId: this.userId, ...params };
    else params = { IdentityUserId: this.userId };
    return this.notificationsFollowUpService.GetalldatabyfilterWithCount(pageIndex, pageSize, params).pipe(takeUntil(this.destroy$));
  }

  showAll(): void {
    const skip = this.allNotifications.length;
    this.getUserNotifications$(skip, this.pageSize, null).subscribe({
      next: (res) => {
        // console.log(res)
        if (res.result.totalcount > 0) {
          const data: notificationsFollowUpDto[] = res.result.items.map((item: any) => item._entitydto);
          data.forEach(element => {
            if (this.allNotifications.some(x => x.id === element.id)) return; //ignore duplicate
            this.allNotifications.push({
              id: element.id,
              icon: 'custom-document-text',
              title: element.tabNotifications.title,
              description: element.tabNotifications.details,
              isread: element.read
            })
          })
        }
      }
    })
  }

  showUnRead(): void {
    const skip = this.unReadNotifications.length;
    this.getUserNotifications$(skip, this.pageSize, { Read: false }).subscribe({
      next: (res) => {
        this.unReadCount = res.result.totalcount
        // console.log(res)
        if (res.result.totalcount > 0) {
          const data = res.result.items.map((item: any) => item._entitydto);
          data.forEach(element => {
            if (this.unReadNotifications.some(x => x.id === element.id)) return; //ignore duplicate
            this.unReadNotifications.push({
              id: element.id,
              icon: 'custom-document-text',
              title: element.tabNotifications.title,
              description: element.tabNotifications.details,
              isread: element.read
            })
          })
        }
      }
    })
  }

  onScroll(): void {
    this.scrollbarRef.scrolled
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: Event) => {
        const scrollElement = event.target as HTMLElement;

        const scrollPosition = scrollElement.scrollTop + scrollElement.clientHeight;
        const scrollHeight = scrollElement.scrollHeight;

        // near to end scroll
        if (scrollPosition >= scrollHeight - 50) {
          if (this.selectedTab === 'unRead') this.showUnRead();
          else this.showAll();

        }
      });
  }

  onTabChange(tab: 'unRead' | 'allNotifications'): void {
    this.scrollbarRef?.scrollTo({ top: 0, duration: 300 });

    if (tab === 'allNotifications') {
      this.allNotifications = [];
      this.showAll();
    } else {
      this.unReadNotifications = [];
      this.showUnRead();
    }
  } //reset all 

  update$(notification) {
    return this.notificationsFollowUpService.update(notification.id, notification).pipe(takeUntil(this.destroy$))
  }


  markAllAsRead(event): void {
    event.stopPropagation();

    const params = { Read: false };

    this.getUserNotifications$(0, 1000, params).pipe(
      map(res => {
        return res?.result?.items.map((item: any) => {
          const entity = item._entitydto;
          entity.read = true;
          return entity;
        }) || [];
      }),
      switchMap((updatedItems) => {
        const updateObservables = updatedItems.map(item => this.update$(item));
        return forkJoin(updateObservables);
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: () => {
        this.unReadCount = null;
        this.unReadNotifications = [];
        this.showAll();
      },
      error: err => {
      }
    });
  } // end markAllAsRead

  notifyClicked(event, card: notificationCardDto): void {
    event.stopPropagation();
    this.update$(card).subscribe({
      next: (res) => {
        card.isread = true;
        this.unReadNotifications = this.unReadNotifications.filter(x => x.id !== card.id); // remove read notification
        this.unReadCount = this.unReadCount - 1 // decrease counter
      }
    })

  }

  //#region signalR
  signalR(): void {
    this.signalRService.start(); // 👈 تشغيل الاتصال

    this.signalRService.notification$.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      // this.NotificationList.unshift({read:false,message:obj["message"],title:obj["title"]});
      // fill NotificationList from backend
      // let message = msg;
      // console.log('🔔 إشعار جديد:', msg);

      //#region get user notifications update after new notification
      this.showAll();
      this.showUnRead();
      //#endregion

      // alert(`🔔notification`)
      this.baseService.showSuccessMessage(obj.message, obj.title);
    });
  }
  //#endregion

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

